<template>
  <div class="template">
    <div class="header">
      <slot name="close"></slot>
      <span>
        <slot name="title"></slot>
      </span>
      <slot name="header-btn"></slot>
    </div>
    <div class="form-list">
      <myScroll style="width:100%;height:100%"
                class="scroll">
        <div style="width:93%;margin: 0 auto">
          <slot name="form"></slot>
        </div>
      </myScroll>
    </div>
    <div class="footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {

  },
  components: {

  }
}
</script>

<style scoped lang="scss">
.template {
  width: 100%;
  height: 100%;
  background-color: #f9f9f9;
  .header {
    padding: 0 10px;
    height: 38px;
    background-color: #fff;
    overflow: hidden;
    border-bottom: 1px solid #dcdfe6;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    span {
      flex-grow: 2;
      text-align: center;
    }
  }
  .footer {
    padding: 0 10px;
    height: 40px;
    overflow: hidden;
    border-top: 1px solid #dcdfe6;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .el-button {
      flex-grow: 2;
    }
    background-color: #fff;
  }
  .form-list {
    width: 100%;
    margin: 0 auto;
    padding-bottom: 10px;
    height: calc(100% - 90px);
  }
}
</style>
